import * as React from 'react';
import { memo } from 'react';

const SvgCalendarBlank = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.3125 2.73047V11.5439H2.6875V2.73047H11.3125Z", fill: "currentColor", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.625 1.33789V3.1222", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.375 1.33789V3.1222", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M2.1875 4.90625H11.8125", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgCalendarBlank);

export { Memo as default };
